module.exports = __webpack_public_path__ + "img/interior_9.655abdc8.jpg";